export default function (injection, Vue, props = {}) {
    let scrollBarWidth;
    const $div = document.createElement('div');
    let util = {
        useDivFixText (text) {
            $div.innerHTML = text;
            return $div.innerText.replace(/</ig, '&lt;').replace(/>/ig, '&gt;');
        },
        noAuthPromise (data, status = 1205) {
            return Promise.reject({
                errcode: status,
                errmessage: '你没有该站点访问权限',
                data: data
            });
        },
        getServiceList (sites, addMore) {
            sites = injection.util.deepCopy(sites);
            let serviceList = {}, more = true;
            sites.forEach(v => {
                let {service_area_id, service_area_name} = v;
                service_area_id = service_area_id || -1;
                service_area_name = service_area_name || '未配置';
                const temp = {
                    value: service_area_id,
                    text: service_area_name,
                    children: addMore ? [{
                        id: `z${service_area_id}`,
                        value: `z${service_area_id}`,
                        text: `${service_area_name.includes('省直') ? '全省' : service_area_name}总览`,
                        service_area_id, service_area_name
                    }] : []
                };
                serviceList[service_area_id] = serviceList[service_area_id] || temp;
                serviceList[service_area_id].children.push({
                    ...v,
                    value: v.id,
                    text: v.name,
                });
            });
            serviceList = Object.values(serviceList);
            more = serviceList.length !== 1;
            if (!more) {
                serviceList = serviceList[0].children;
            }

            return {
                more,
                serviceList: serviceList.sort((v1, v2) => {
                    return v1.value === -1 ? 1 : v1.value - v2.value;
                })
            };
        },
        request (url = window.location.href, withHash = false) {
            let map = {}, j,
                i = url.indexOf('?'),
                m = url.indexOf('#');
            if (i < 0) {
                return map;
            }
            const hashIdx = m;
            j = m > 0 ? (url.slice(i + 1, m)) : j = url.slice(i + 1);
            m = j.split('&');
            for (i = 0; i < m.length; i++) {
                j = m[i].indexOf('=');
                if (j <= 0) {
                    continue;
                }
                map[m[i].slice(0, j)] = decodeURIComponent(m[i].slice(j + 1));
            }
            if (withHash) {
                j = url.slice(hashIdx + 1, url.length);
                j = util.request(j);
                Object.assign(map, j);
            }
            return map;
        },
        statistics (appid, siteid) {
            const $body = document.querySelector('body');
            const $img = document.createElement('img');
            const load = () => {
                $img.removeEventListener('load', load);
                $body.removeChild($img);
            };
            $img.addEventListener('load', load, true);
            $img.src = `http://statistics.gd.gov.cn/visit/visit?appid=${appid}&site=${siteid}`;
            $body.appendChild($img);
        },
        goBack (fn) {
            if (window.history.length === 1) {
                fn && fn();
            } else {
                window.history.go(-1);
            }
        },
        uniqueArray (arr) {
            return [...new Set(arr)];
        },
        randomColor () {
            return `#${Math.floor(Math.random() * 0xffffff).toString(16).padEnd(6, '0')}`;
        },
        random11Str () {
            return Math.random().toString(36).substring(2);
        },
        randomId () {
            return `id_${(Math.random() * 100000000000000000)}`;
        },
        checkIEVersion () {
            const ua = window.navigator.userAgent;

            const msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            const trident = ua.indexOf('Trident/');
            if (trident > 0) {
                const rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }
        },
        isIE () {
            return (!!window.ActiveXObject || 'ActiveXObject' in window);
        },
        deepCopy (data) {
            return JSON.parse(JSON.stringify(data));
        },
        HTMLDecode (text) {
            const temp = document.createElement('div');
            temp.innerHTML = text;
            return temp.innerHTML || temp.textContent;
        },
        getBlobBydataURI (dataURI, type) {
            let binary = window.atob(dataURI);
            let array = [];
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new window.Blob([new Uint8Array(array)], {type: type});
        },
        clearHTML (str, rep = '') {
            return str.replace(/<[^>]*>|<\/[^>]*>/gm, rep);
        },
        cleanText (str) {
            if (typeof str === 'number') {
                return str;
            } else if (!str) {
                return '';
            }
            str = str.replace(/<\/?[^>]*>/gm, ''); //去除HTML tag
            str = str.replace(/[ | ]*\n/gm, '\n'); //去除行尾空白
            str = str.replace(/\n[\s| | ]*\r/gm, '\n'); //去除多余空行
            str = str.replace(/^[\s]+|[\s]+$/gm, '');//去掉全角半角空格
            str = str.replace(/[\r\n]/gm, '');//去掉回车换行
            return str.trim();
        },
        mkurl (url, args, isRestful) {
            let fi = true;
            if (isRestful) {
                args = args.join('/');
                if (url[url.length - 1] === '/') {
                    url = `${url}${args}`;
                } else {
                    url = `${url}/${args}`;
                }
            } else {
                if (args) {
                    for (let i in args) {
                        if (fi) {
                            fi = false;
                            url += '?' + i + '=' + encodeURIComponent(args[i]);
                        } else {
                            url += '&' + i + '=' + encodeURIComponent(args[i]);
                        }
                    }
                }
            }
            return url;
        },
        highLight (content, keyword, color = '#008afe') {
            if (util.validate.isEmpty(keyword)) {
                return content;
            } else if (util.validate.isEmpty(content)) {
                return '';
            }
            keyword = keyword.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
            let replaceStr = `<span style='color:${color}'>$1</span>`;
            let reg = new RegExp('(' + keyword + ')', 'ig');
            return content.replace(reg, replaceStr);
        },
        getScrollBarWidth () {
            if (scrollBarWidth !== undefined) return scrollBarWidth;
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            outer.style.position = 'absolute';
            outer.style.top = '-9999px';
            document.body.appendChild(outer);

            const widthNoScroll = outer.offsetWidth;
            outer.style.overflow = 'scroll';

            const inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);

            const widthWithScroll = inner.offsetWidth;
            outer.parentNode.removeChild(outer);
            scrollBarWidth = widthNoScroll - widthWithScroll;

            return scrollBarWidth;
        },
        resetQuot (str) {
            if (!str) {
                return str;
            }
            let changeStr = '';
            changeStr = str.replace(/&amp;/g, '&');
            changeStr = changeStr.replace(/&nbsp;/g, ' ');
            changeStr = changeStr.replace(/&lt;/g, '<');
            changeStr = changeStr.replace(/&gt;/g, '>');
            changeStr = changeStr.replace(/\r\n/g, '<br>');
            changeStr = changeStr.replace(/&quot;/g, '"');
            changeStr = changeStr.replace(/&ldquo;/g, '“');
            changeStr = changeStr.replace(/&rdquo;/g, '”');
            changeStr = changeStr.replace(/&rdquo;/g, '”');
            changeStr = changeStr.replace(/&lsquo;/g, '‘');
            changeStr = changeStr.replace(/&rsquo;/g, '’');
            return changeStr;
        },
        validator () {
            return {
                isEmpty (obj) {
                    if (Array.isArray(obj)) {
                        return !obj.length;
                    } else if (typeof obj === 'object') {
                        return !obj;
                    } else if (obj === undefined) {
                        return true;
                    } else if (typeof obj === 'string' && !obj.length) {
                        return true;
                    }
                    return false;
                },
                isNumeric (obj) {
                    return !isNaN(parseFloat(obj)) && isFinite(obj);
                },
                numeric (obj) {
                    return this.isNumeric(obj);
                },
                numberic (obj) {
                    return this.isNumeric(obj);
                },
                email (obj) {
                    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(obj);
                },
                chinese (obj) {
                    return /^[\u4e00-\u9fa5]{0,}$/.test(obj);
                },
                english (obj) {
                    return /^[a-zA-Z]+$/.test(obj);
                },
                url (obj) {
                    return /(^#)|(^http(s*):\/\/[^\s]+\.[^\s]+)/.test(obj);
                },
                idcard (obj) {
                    return /(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(obj);
                },
                mobile (obj) {
                    return /^1(2|3|4|5|6|7|8|9)[0-9]\d{8}$/.test(obj);
                },
                document (obj) {
                    return /\.doc(x?)$|\.xls(x?)$|\.ppt(x?)$|\.wps$|\.pdf$|\.txt$/i.test(obj);
                },
                image (obj) {
                    return /\.png|\.jpg$|\.jpeg$|\.bmp$|\.gif$/i.test(obj);
                },
                video (obj) {
                    return /\.wmv$|\.avi$|\.mkv$|\.rm$|\.mov$|\.mp4$|\.rmvb$/i.test(obj);
                },
                audio (obj) {
                    return /\.mp3/i.test(obj);
                },
                archive (obj) {
                    return /\.rar$|\.zip$|\.7z$|\.gzip$|\.tar$|\.iso$/i.test(obj);
                },
                english_or_numeric: function (str) {
                    return /^[A-Za-z0-9]+$/g.test(str);
                },
                unified_social_credit_code: function (str) {
                    return str.length === 18 && window.Util.validate.english_or_numeric(str);
                }
            };
        },
        browser () {
            const u = navigator.userAgent;
            return {
                trident: u.indexOf('Trident') > -1,
                presto: u.indexOf('Presto') > -1,
                webKit: u.indexOf('AppleWebKit') > -1,
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
                mobile: !!u.match(/AppleWebKit.*Mobile.*/),
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
                iPhone: u.indexOf('iPhone') > -1,
                iPad: u.indexOf('iPad') > -1,
                webApp: u.indexOf('Safari') === -1,
                weixin: u.indexOf('MicroMessenger') > -1,
                qq: u.match(/\sQQ/i) === ' qq'
            };
        },
        classNames (...args) {
            const classes = [];

            args.forEach(val => {
                if (!val) {
                    return;
                }
                const argType = typeof val;
                if (argType === 'string' || argType === 'number') {
                    classes.push(val);
                } else if (Array.isArray(val)) {
                    classes.push(util.classNames(val));
                } else if (argType === 'object') {
                    Object.keys(val).forEach(k => {
                        if (val[k]) {
                            classes.push(k);
                        }
                    })
                }
            });

            return classes.join(' ');
        }
    };

    util.validate = util.validator();

    util = Object.assign(util, props);

    Object.defineProperties(injection, {
        util: {
            get () {
                return util;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $util: {
            get () {
                return util;
            }
        }
    });
}
